import { Methods, RestClient } from 'o2o_layout/lib/common/rest';

import { TRequestUpdateOrg2FAPolicy } from './type';
import { BIGDATA_CONSTANT } from '../../../../../../../common/constant';

const UpdateOrg2FAPolicy = (request: TRequestUpdateOrg2FAPolicy) => {
  let url = BIGDATA_CONSTANT.url.api + 'mngmnt-client/orgs/config/2fa-policy/save';

  let restClient = new RestClient(Methods.POST, url);

  return new Promise((resolve, reject) => {
    restClient.execute({}, request).then(
      (response: any) => {
        const user: any = response.data;
        resolve(user);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export default UpdateOrg2FAPolicy;
